import { enableLog } from "@ca.vmedia.tv/domains";

export class Logger {

    static captureLog(
        log: string | unknown, 
    ): void {
        if (enableLog) {
            console.log(log);
        }
    }

    static captureError(
        error: Error, 
    ): void {
        console.error(error);
    }

    super() {
        return this;
    }
}
